module.exports = __webpack_public_path__ + "img/TrackNotAvailable_Networking.2884f068.png";